export * from './content-switcher.component';